import {
    useMutation,
    UseMutationResult,
} from '@tanstack/react-query'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'
import request from 'app/requests/Lane/Lane.requests'
import simpleApi from 'app/services/simpleApi'

type RequestParams = {
    lanes: {id: number}[],
    opportunity: {id: number},
}

const useAssignmentToOpportunity = (onAssigned: () => void)
    : UseMutationResult<unknown, unknown, RequestParams> => {
    const token = useJWTToken()
    const {
        onSuccess: onSuccessAssignment,
        onError,
    } = useHandleStatusRequest({
        id: 'AssignmentToOpportunity',
        onSuccess: onAssigned,
        onError: onAssigned,
    })

    return useMutation({
        mutationFn: (data: RequestParams) => {
            return simpleApi({
                ...request.assignmentToOpportunity({
                    data,
                }),
                token,
            })
        },
        onSuccess: onSuccessAssignment,
        onError,
    })
}

export default useAssignmentToOpportunity
